<footer class="b4a-tv-footer">
  <div class="b4a-footer-content">
    <ng-content></ng-content>
  </div>
</footer>

